import React from 'react';

const DisinfectionColumns = () => (
  <tr>
    <th>Actions</th>
    <th>Numéro</th>
    <th>Produit</th>
    <th>Manip. Produit</th>
    <th>
      Matériel
      <br />
      Complémentaire
    </th>
    <th>
      Manip. Matériel
      <br />
      Complémentaire
    </th>
  </tr>
);

export default DisinfectionColumns;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/components/types/DisinfectionColumns.js